// extracted by mini-css-extract-plugin
export var gift = "style-module--gift--28e58";
export var giftInfo = "style-module--gift-info--ec19e";
export var info = "style-module--info--55a1d";
export var screen1 = "style-module--screen1--2d45a";
export var timer = "style-module--timer--39584";
export var timerWrap = "style-module--timer-wrap--8f14c";
export var type = "style-module--type--7eeae";
export var wrapper = "style-module--wrapper--6d73f";